import * as React from 'react';
import {authorize, IWithRouterProps, Overlay, withRouter} from "@athena-portal/components";
import {lazyInject} from "@athena-portal/core";
import {
    FalconPaymentRequest,
    ICacheManager,
    InstalmentsInfo,
    INTERACTION_PROCESS_MTA_ADD_PAY_OFF_BALANCE,
    ProductsEnum,
    Types,
    VerifyNewCardResponse
} from "@ferry/journey-services";
import {getAmountWithDecimalDigits, getSessionStorage} from "../../../../../CommonFunctions";
import {Navigate} from "react-router-dom";
import {Types as CustomerPortalTypes} from "../../../../../Types";
import type {ICustomerPortalService} from "../../../../../services/ICustomerPortalService";

interface IParams {
    policyNumber: string;
    paymentReference: string;
    [key: string]: string | undefined
}

interface IState {
   paymentFailed?: boolean;
   paymentCancelled?: boolean;
   payOffAmount?: number;
}

@authorize
export class PayOffBalanceProcessingPagePlain extends React.Component<IWithRouterProps<IParams>, IState> {

    @lazyInject(CustomerPortalTypes.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    @lazyInject(Types.CacheManager)
    private cacheManager: ICacheManager;

    constructor(props: IWithRouterProps<IParams>) {
        super(props);

        this.state = {}
    }

    public componentDidMount(): void {
        const policyNumber: string = this.props.params.policyNumber;
        const reuseCard: any = getSessionStorage("reuseCard") || false;
        const request: FalconPaymentRequest = new FalconPaymentRequest();
        request.invoiceType = "PAYOFF";
        request.product = ProductsEnum.WOLF_MOTOR;

        this.customerPortalService.getInstalmentsInfo(this.props.params.policyNumber, false).subscribe((output: InstalmentsInfo) => {
            this.setState({
                payOffAmount: output.payOffAmount,
            })
        });

        if (this.props.params.paymentReference) {
            this.customerPortalService.payOffBalanceWithNewCard(request, policyNumber, this.props.params.paymentReference, reuseCard).subscribe((response: VerifyNewCardResponse) => {

                if (response.successful) {
                    window.sessionStorage.setItem("showPopup", "true");
                    window.sessionStorage.setItem("paymentAmount", getAmountWithDecimalDigits(this.state.payOffAmount).toString());
                    window.sessionStorage.setItem("referrerJourney", INTERACTION_PROCESS_MTA_ADD_PAY_OFF_BALANCE);

                    this.cacheManager.clearCache(`getPolicyPropertyByPropertyKey${policyNumber},mainAnnualPaymentCard`);
                    this.cacheManager.clearCache(`getAnnualPolicyInfo${policyNumber}`);

                    window.location.href = `/dashboard/monthlyPaymentHistory/${policyNumber}`;
                } else if (response.cancelled) {
                    this.setState({
                        paymentCancelled: true
                    })
                } else {
                    this.setState({
                        paymentFailed: true
                    })
                }
            })
        }
    }

    public render(): React.ReactNode {
        if (this.state.paymentFailed) {
            return <Navigate to={{pathname: `/dashboard/${this.props.params.policyNumber}/payOffBalance/newCard`,}}
                             state={{
                                paymentFailed: this.state.paymentFailed
                            }} />
        } else if (this.state.paymentCancelled) {
            return (
                <Navigate to={{
                    pathname: `/dashboard/monthlyPaymentHistory/${this.props.params.policyNumber}`
                }} />
            )
        } else {
            return <Overlay show={true}/>
        }
    }
}

export const PayOffBalanceProcessingPage = withRouter<{}, IParams>(PayOffBalanceProcessingPagePlain)
